<div class="search-wrapper mt-16 mt-sm-0">
  <div class="search" fxFlex fxLayout="row" fxLayoutAlign="center center">
    <mat-icon>search</mat-icon>
    <label class="no-display" for="appSearchBar"></label>
    <input id="appSearchBar" [(ngModel)]="searchValue" [placeholder]="placeholder" autocomplete="off">
  </div>
</div>
